import { useState } from 'react'
import OneRatio from './../../assets/images/landing-page/one_ratio.png'
import OneRatioMobile from './../../assets/images/landing-page/one_ratio_mobile.png'
import MultipleRatios from './../../assets/images/landing-page/multiple_ratios.png'
import MultipleRatiosMobile from './../../assets/images/landing-page/multiple_ratios_mobile.png'
import WithAI from './../../assets/images/landing-page/with_ai.png'
import WithoutAI from './../../assets/images/landing-page/without_ai.png'
import Netflix from './../../assets/images/landing-page/netflix.png'
import Drawkit from './../../assets/images/landing-page/drawkit.png'
import Figma from './../../assets/images/landing-page/figma.png'
import Stripe from './../../assets/images/landing-page/stripe.png'
import TestimonialLeft from './../../assets/images/landing-page/testimonial_left.png'
import TestimonialRight from './../../assets/images/landing-page/testimonial_right.png'
import PersonOne from './../../assets/images/landing-page/person_1.png'
import PersonTwo from './../../assets/images/landing-page/person_2.png'
import PersonThree from './../../assets/images/landing-page/person_3.png'
import CredentialsImage from './../../assets/images/landing-page/credentials.png'

const testimonials = [
  {
    author: 'Orsolya Anna Tóth',
    message:
      'Software that is not just a one-trick pony but makes many different aspects of video work easier and smoother.',
  },
  {
    author: 'Angela Kanwar',
    message:
      'It has been convenient and time saving to have such engaging content made for all our social platforms at the same time. We like our members to tell their own stories, so having a voiceover telling the story and background music accompanying it has been a big win for us.',
  },
  {
    author: 'Markus Beeken',
    message:
      'Seeing this go from concept to final version, and exactly the way I wanted it to be, was made all the easier using the Cerebriam Studio online editor. An intuitive, simple platform for video editing.',
  },
 // {
  //  author: 'Tobi Hashima',
   // message:
     // 'Qs far as I know, all the housing made by Lucy Properti has a very strategic location, close to the center of the Government, making it easier for us to carry out activities',
  //},
  //{
   // author: 'Morris Davies',
  //  message:
    //  'Rs far as I know, all the housing made by Lucy Properti has a very strategic location, close to the center of the Government, making it easier for us to carry out activities',
 // },
]

const Services = ({ setIsSignUpOpen }) => {
  const [activeTestimonial, setActiveTestimonial] = useState(2)
  const changeTestimonial = (value) => {
    setActiveTestimonial(value)
  }
  return (
    <section className="cerebriam-services">
      <div className="cerebriam-container">
        <div className="cerebriam-content animate__animated animate__zoomIn">
          <svg
            width="51"
            height="52"
            viewBox="0 0 51 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M34.75 6.00006C35.0815 6.00006 35.3995 5.86837 35.6339 5.63394C35.8683 5.39952 36 5.08158 36 4.75006V2.25006C36 1.91854 35.8683 1.6006 35.6339 1.36618C35.3995 1.13176 35.0815 1.00006 34.75 1.00006C34.4185 1.00006 34.1005 1.13176 33.8661 1.36618C33.6317 1.6006 33.5 1.91854 33.5 2.25006V4.75006C33.5 5.08158 33.6317 5.39952 33.8661 5.63394C34.1005 5.86837 34.4185 6.00006 34.75 6.00006Z"
              fill="green"
            />
            <path
              d="M47.2501 18.5001H49.7501C50.0816 18.5001 50.3996 18.3684 50.634 18.1339C50.8684 17.8995 51.0001 17.5816 51.0001 17.2501C51.0001 16.9185 50.8684 16.6006 50.634 16.3662C50.3996 16.1318 50.0816 16.0001 49.7501 16.0001H47.2501C46.9186 16.0001 46.6007 16.1318 46.3662 16.3662C46.1318 16.6006 46.0001 16.9185 46.0001 17.2501C46.0001 17.5816 46.1318 17.8995 46.3662 18.1339C46.6007 18.3684 46.9186 18.5001 47.2501 18.5001Z"
              fill="green"
            />
            <path
              d="M42.2501 11.0002C42.4141 11.0022 42.5766 10.9699 42.7273 10.9053C42.878 10.8407 43.0135 10.7453 43.1251 10.6252L45.6251 8.12519C45.74 8.01029 45.8312 7.87387 45.8934 7.72374C45.9556 7.57361 45.9876 7.4127 45.9876 7.25019C45.9876 7.08769 45.9556 6.92678 45.8934 6.77665C45.8312 6.62651 45.74 6.4901 45.6251 6.37519C45.5102 6.26029 45.3738 6.16914 45.2237 6.10695C45.0736 6.04476 44.9126 6.01276 44.7501 6.01276C44.5876 6.01276 44.4267 6.04476 44.2766 6.10695C44.1265 6.16914 43.99 6.26029 43.8751 6.37519L41.3751 8.87519C41.2556 8.98742 41.1603 9.12296 41.0951 9.27346C41.0299 9.42395 40.9963 9.5862 40.9963 9.75019C40.9963 9.91419 41.0299 10.0764 41.0951 10.2269C41.1603 10.3774 41.2556 10.513 41.3751 10.6252C41.4867 10.7453 41.6223 10.8407 41.773 10.9053C41.9236 10.9699 42.0862 11.0022 42.2501 11.0002Z"
              fill="green"
            />
            <path
              d="M38.3499 13.6502C34.3428 9.49601 29.743 5.95768 24.6999 3.15023C19.9749 0.650228 16.4999 0.325229 14.6999 2.17523C14.2942 2.59997 13.9787 3.10248 13.7725 3.65245C13.5663 4.20241 13.4735 4.78845 13.4999 5.37523V21.6502C13.4702 23.2802 12.8171 24.8369 11.6749 26.0002L3.97492 33.7752C3.03007 34.7057 2.27973 35.8148 1.76756 37.0381C1.2554 38.2613 0.991638 39.5741 0.991638 40.9002C0.991638 42.2263 1.2554 43.5392 1.76756 44.7624C2.27973 45.9856 3.03007 47.0947 3.97492 48.0252C4.90541 48.9701 6.01453 49.7204 7.23774 50.2326C8.46095 50.7448 9.77381 51.0085 11.0999 51.0085C12.426 51.0085 13.7389 50.7448 14.9621 50.2326C16.1853 49.7204 17.2944 48.9701 18.2249 48.0252L18.4999 47.7752L19.8249 49.0752C20.4276 49.6895 21.1476 50.1764 21.9421 50.5071C22.7366 50.8377 23.5894 51.0055 24.4499 51.0002C26.1851 50.9936 27.8473 50.3014 29.0742 49.0745C30.3011 47.8476 30.9933 46.1854 30.9999 44.4502C31.0051 43.5897 30.8374 42.7369 30.5068 41.9424C30.1761 41.1479 29.6892 40.4279 29.0749 39.8252L28.1749 38.9002C28.8715 38.6427 29.6073 38.5074 30.3499 38.5002H47.2499C47.4315 38.4943 47.6101 38.4518 47.7749 38.3752C48.5531 38.2539 49.2718 37.8859 49.8249 37.3252C51.6749 35.5002 51.3249 32.0252 48.8499 27.3252C46.0445 22.2733 42.5061 17.665 38.3499 13.6502ZM16.4249 3.92523C16.8399 3.6107 17.3558 3.45947 17.8749 3.50023C19.8639 3.6922 21.7853 4.32412 23.4999 5.35023C28.3044 8.04442 32.6989 11.4118 36.5499 15.3502C40.4883 19.2013 43.8557 23.5958 46.5499 28.4002C48.6999 32.5252 48.6499 34.8252 47.9749 35.5252C47.7737 35.689 47.5417 35.8109 47.2928 35.8839C47.0438 35.9569 46.7827 35.9794 46.5249 35.9502C43.1032 35.4149 39.8756 34.012 37.1499 31.8752C36.1749 31.2002 35.2499 30.5002 34.3499 29.8002C34.6007 28.99 34.7354 28.1483 34.7499 27.3002C34.7621 25.7478 34.4127 24.2138 33.7293 22.8198C33.0458 21.4257 32.0472 20.21 30.8125 19.2688C29.5778 18.3276 28.141 17.6869 26.6157 17.3972C25.0904 17.1076 23.5187 17.1771 22.0249 17.6002C21.3499 16.7002 20.6499 15.7752 19.9749 14.8002C17.8662 12.0499 16.4976 8.80499 15.9999 5.37523C15.9707 5.11742 15.9933 4.85637 16.0663 4.60739C16.1392 4.35841 16.2612 4.12649 16.4249 3.92523ZM32.2749 28.0752C30.7749 26.8252 29.3249 25.5752 27.8999 24.1002C26.4749 22.6252 25.1749 21.2252 23.9249 19.7252C24.9846 19.5935 26.0602 19.6896 27.0798 20.007C28.0994 20.3245 29.0394 20.856 29.837 21.566C30.6346 22.2761 31.2714 23.1482 31.7047 24.1242C32.1381 25.1002 32.3581 26.1574 32.3499 27.2252C32.3499 27.5502 32.2999 27.8002 32.2749 28.0752ZM5.72492 46.2752C5.00675 45.5764 4.43591 44.7406 4.04614 43.8175C3.65636 42.8943 3.45554 41.9023 3.45554 40.9002C3.45554 39.8981 3.65636 38.9062 4.04614 37.983C4.43591 37.0598 5.00675 36.2241 5.72492 35.5252L6.14992 35.1002C6.51086 37.8246 7.75955 40.3541 9.7028 42.2973C11.6461 44.2406 14.1755 45.4893 16.8999 45.8502L16.4749 46.2752C15.0279 47.6597 13.1025 48.4324 11.0999 48.4324C9.0973 48.4324 7.17191 47.6597 5.72492 46.2752ZM27.3249 41.5752C28.0762 42.3439 28.4978 43.3754 28.4999 44.4502C28.5004 45.5256 28.0785 46.5581 27.3249 47.3252C26.5434 48.0509 25.5164 48.4543 24.4499 48.4543C23.3834 48.4543 22.3564 48.0509 21.5749 47.3252L20.2749 46.0002L25.9999 40.3252L27.3249 41.5752ZM30.3499 36.0002C29.2061 35.9853 28.0708 36.1988 27.0105 36.628C25.9502 37.0573 24.9862 37.6938 24.1749 38.5002L19.2749 43.5002H18.4999C15.8478 43.5002 13.3042 42.4467 11.4289 40.5713C9.55349 38.6959 8.49992 36.1524 8.49992 33.5002C8.48656 33.2421 8.48656 32.9834 8.49992 32.7252L13.4999 27.7252C14.3019 26.9107 14.9354 25.946 15.3644 24.8865C15.7933 23.827 16.0093 22.6933 15.9999 21.5502V12.8752C16.6499 14.0502 17.3499 15.1752 18.0249 16.1502C18.9999 17.6002 19.9999 18.9252 21.0249 20.1752C22.6322 22.1557 24.3429 24.05 26.1499 25.8502C27.9749 27.6752 29.8749 29.4002 31.7999 30.9752C33.0749 32.0002 34.2999 32.9752 35.8499 33.9752C36.8249 34.6502 37.9499 35.3502 39.1249 36.0002H30.3499Z"
              fill="green"
            />
          </svg>

          <h3>Reach the people who need to know</h3>
          <p>
            Easily re-purpose your video content and cross-post on learning platforms, websites, and social channels to grow and increase your engagement. 
          </p>

        </div>
        <div className="cerebriam-content animate__animated animate__zoomIn">
          <svg
  width="50"
  height="60"
  viewBox="0 0 50 60"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.75 6.25H41.25C42.6307 6.25 43.75 7.36929 43.75 8.75V32.5C43.75 33.8807 42.6307 35 41.25 35H8.75C7.36929 35 6.25 33.8807 6.25 32.5V8.75C6.25 7.36929 7.36929 6.25 8.75 6.25ZM8.75 8.75V32.5H41.25V8.75H8.75Z"
    fill="#01C67F"
  />
  <path
    d="M15 15H35C35.6904 15 36.25 15.5596 36.25 16.25C36.25 16.9404 35.6904 17.5 35 17.5H15C14.3096 17.5 13.75 16.9404 13.75 16.25C13.75 15.5596 14.3096 15 15 15Z"
    fill="#01C67F"
  />
  <path
    d="M15 22.5H28.75C29.4404 22.5 30 23.0596 30 23.75C30 24.4404 29.4404 25 28.75 25H15C14.3096 25 13.75 24.4404 13.75 23.75C13.75 23.0596 14.3096 22.5 15 22.5Z"
    fill="#01C67F"
  />
  <path
    d="M25 35C25.6904 35 26.25 35.5596 26.25 36.25V52.5C26.25 53.1904 25.6904 53.75 25 53.75C24.3096 53.75 23.75 53.1904 23.75 52.5V36.25C23.75 35.5596 24.3096 35 25 35Z"
    fill="#01C67F"
  />
  <path
    d="M15 53.75C14.3096 53.75 13.75 53.1904 13.75 52.5C13.75 51.8096 14.3096 51.25 15 51.25H35C35.6904 51.25 36.25 51.8096 36.25 52.5C36.25 53.1904 35.6904 53.75 35 53.75H15Z"
    fill="#01C67F"
  />
  <path
    d="M32.5 27.5C32.5 26.8096 33.0596 26.25 33.75 26.25H36.25C36.9404 26.25 37.5 26.8096 37.5 27.5V30C37.5 30.6904 36.9404 31.25 36.25 31.25H33.75C33.0596 31.25 32.5 30.6904 32.5 30V27.5Z"
    fill="#01C67F"
  />
</svg>
        
          <h3>Focus on the message</h3>
          <p>
            Cut your editing time in half. Spend more time producing creative communications or simply take a break with all of your spare time ;-)
          </p>
        </div>
        <div className="cerebriam-content animate__animated animate__zoomIn">
 
          <svg
  width="50"
  height="50"
  viewBox="0 0 50 50"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M25 0.75L43.75 7.5V22.5C43.75 34.25 36.15 44.7 25 49.25C13.85 44.7 6.25 34.25 6.25 22.5V7.5L25 0.75ZM25 3.45L8.75 9.3V22.5C8.75 32.75 15.25 41.95 25 46.55C34.75 41.95 41.25 32.75 41.25 22.5V9.3L25 3.45Z"
    fill="#FF9292"
  />
  <path
    d="M22.1 30.65L34.2 18.55C34.6875 18.0625 35.475 18.0625 35.9625 18.55C36.45 19.0375 36.45 19.825 35.9625 20.3125L23 33.275C22.5125 33.7625 21.725 33.7625 21.2375 33.275L14.0375 26.075C13.55 25.5875 13.55 24.8 14.0375 24.3125C14.525 23.825 15.3125 23.825 15.8 24.3125L22.1 30.65Z"
    fill="#FF9292"
  />
  <path
    d="M25 8.75L36.25 12.8V22.5C36.25 30.35 31.85 37.4 25 41.25C18.15 37.4 13.75 30.35 13.75 22.5V12.8L25 8.75ZM25 11.4L16.25 14.55V22.5C16.25 29.05 19.7 35 25 38.35C30.3 35 33.75 29.05 33.75 22.5V14.55L25 11.4Z"
    fill="#FF9292"
    opacity="0.35"
  />
</svg>

          <h3>Keep your brand trusted</h3>
          <p>
            Add C2PA Content Credentials so your videos carry clear signals about origin, authorship and usage rights - even in a world of deepfakes, copycats and AI confusion.
          </p>
        </div>
      </div>

      <div className="cerebriam-row walkthrough">
        <div className="cerebriam-col-6 image">
          <div className="cerebriam-content animate__animated animate__fadeIn">
            <img className="desktop" src={MultipleRatios} alt="multiple" />
            <img className="mobile" src={MultipleRatiosMobile} alt="multiple" />
          </div>
        </div>
        <div className="cerebriam-col-6 content">
          <div className="cerebriam-content">
            <h2>
              Compose and create multiple aspect ratio videos
            </h2>
            <p>
            Important messages should not get trapped in one format.

          With Cerebriam Studio, you can create up to four aspect-ratio videos at the same time - helping you adapt lessons, explainers, briefings and campaign content for the places people actually watch.

          Create once. Share everywhere.
              
            </p>
            <button  onClick={() => setIsSignUpOpen(true)}>
              START FREE TRIAL
            </button>
          </div>
        </div>
      </div>

      <div className="cerebriam-row walkthrough">
        <div className="cerebriam-col-6 content second">
          <div className="cerebriam-content">
            <h2>One editor to rule them all </h2>
            <p>
              Be in control with a powerful, patent pending, editor which automatically applies all the video,
              photo, sound, and text edits made to one aspect ratio to all the
              other aspect ratios.
            </p>
            <button onClick={() => setIsSignUpOpen(true)}>
              START FREE TRIAL
            </button>
          </div>
        </div>
        <div className="cerebriam-col-6 image">
          <div className="cerebriam-content animate__animated animate__fadeIn">
            <img className="desktop" src={OneRatio} alt="multiple" />
            <img className="mobile" src={OneRatioMobile} alt="multiple" />
          </div>
        </div>
      </div>

      <div className="cerebriam-row cerebriam-tracking">
  <div className="cerebriam-col-6 images">
    <div className="cerebriam-card credentials-card">
      <div className="cerebriam-image credentials-image animate__animated animate__fadeIn">
        <div className="cerebriam-image-headings">
          <h3>Human Created</h3>
          <h3>GenAI Created</h3> 
        </div>

        <img
          src={CredentialsImage}
          alt="C2PA Content Credentials with origin, authorship and rights information"
        />
      </div>
    </div>
  </div>

  <div className="cerebriam-col-6 content">
    <div className="cerebriam-content">
      <h2>Label and protect your content with C2PA Content Credentials</h2>
      <p>
        When your video explains something important, people should know they can trust it.
        <br /><br />
        In a world of deepfakes, copied content and AI-generated confusion, C2PA Content Credentials
        help show where your video came from, who created it and how it can be used.
        <br /><br />
        Add origin, authorship and rights information to your videos so they carry trusted context
        as they move across formats and channels.
      </p>
      <button onClick={() => setIsSignUpOpen(true)}>
        START FREE TRIAL
      </button>
    </div>
  </div>
</div>

      <div className="cerebriam-row partnership">
        <div className="cerebriam-col-6 texts">
          <div className="cerebriam-content">
            <h2>PARTNERSHIPS</h2>
            <h3>We love working with people with something important to share</h3> 
           
            <p>
            If you work on public-information campaigns, learning content, internal comms, explainers, briefings or training videos, you shouldn't need a production department just to get the message out in the right format.
            </p>

            {/* <div className="cerebriam-row partners-logos">
              <img className="img-1" src={Netflix} alt="netflix" />
              <img className="img-2" src={Drawkit} alt="" />
            </div>
            <div className="cerebriam-row partners-logos">
              <img className="img-1" src={Figma} alt="figma" />
              <img className="img-2" src={Stripe} alt="stripe" />
            </div> */}
          </div>
        </div>
        <div className="cerebriam-col-6 bg-img">
          <div className="cerebriam-content"></div>
        </div>
      </div>

      <div className="dark-bg">
        <div className="cerebriam-content">
          <h2>
            Made for serious ideas, not boring videos
          </h2>
          <p>
            Serious content doesn't have to be boring. With multi-format editing and Content Credentials for trusted media, Cerebriam Studio helps you turn complicated messages into clear, engaging video - from first edit to final publish.
            {' '}
          </p>
          <button onClick={() => setIsSignUpOpen(true)}>
            TRY FOR FREE{' '}
          </button>
        </div>
      </div>

      <div className="testimonial">
        <img
          className="testimonial-bg-img left"
          src={TestimonialLeft}
          alt="testimonial-left"
        />
        <img
          className="testimonial-bg-img right"
          src={TestimonialRight}
          alt="testimonial-right"
        />
        <div className="cerebriam-content">
          <h2>TESTIMONIALS</h2>
          <h3>Our clients are a great bunch</h3>
          <p>{testimonials[activeTestimonial]?.message}</p>
          <div className="photos animate__animated animate__fadeInUp">
            <div
              className={`photo${activeTestimonial === 0 ? ' active' : ''}`}
              onClick={() => changeTestimonial(0)}>
              <img src={PersonOne} alt="person" />
            </div>
            <div
              className={`photo${activeTestimonial === 1 ? ' active' : ''}`}
              onClick={() => changeTestimonial(1)}>
              <img src={PersonTwo} alt="person" />
            </div>
            <div
              className={`photo${activeTestimonial === 2 ? ' active' : ''}`}
              onClick={() => changeTestimonial(2)}>
              <img src={PersonThree} alt="person" />
            </div>
            {/* <div
              className={`photo${activeTestimonial === 3 ? ' active' : ''}`}
              onClick={() => changeTestimonial(3)}>
              <img src={PersonOne} alt="person" />
            </div> */}
            {/* <div
              className={`photo${activeTestimonial === 4 ? ' active' : ''}`}
              onClick={() => changeTestimonial(4)}>
              <img src={PersonOne} alt="person" />
            </div> */}
          </div>
          <p className="author-name">
            {testimonials[activeTestimonial]?.author}
          </p>
        </div>
      </div>
    </section>
  )
}

export default Services
